export const GENDER = [
  { value: 'male', text: 'Male' },
  { value: 'female', text: 'Female' }
]